// Module
var code = `<div class="page-item--cart">
  <header class="cart-header">
    <h2 class="cart-title">{{title}}</h2>
    <p class="cart-subtitle">{{subtitle}}</p>
  </header>

  <p class="cart-empty">{{emptyText}}</p>

  <ul class="cart-lines" aria-live="polite"></ul>

  <p class="cart-test-mode" role="note" hidden>{{testModeText}}</p>
  <p class="cart-password-hint" role="note" hidden>
    {{passwordHintText}}
    <a class="cart-password-hint__link" href="{{attrStoreUnlockHref}}" target="_blank" rel="noopener">{{passwordHintLinkText}}</a>
  </p>

  <footer class="cart-summary">
    <p class="cart-total" role="status" aria-live="polite">
      <span class="cart-total__label">{{subtotalLabel}}</span>
      <span class="cart-total__value"></span>
    </p>
    <button
      type="button"
      class="cart-checkout btn btn-primary"
      data-action="checkout"
      data-checkout-url=""
    >
      {{checkoutLabel}}
    </button>
  </footer>

  <p class="cart-error" role="alert"></p>
</div>
`;
// Exports
module.exports = code;